import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import WebDevelopmentContent from "../components/WebDevelopmentContent";
import Footer from "../components/Footer";

const WebDevelopment = () => {
  return (
    <div>
      <NavBar />
      {/* <HeroImage2
        bgImage="hero-img-projects"
        heading="WEB DEVELOPMENT"
        text="Experience digital innovation."
      /> */}
      <div style={{ paddingTop: "100px" }}>
        <WebDevelopmentContent />
      </div>
      
      {/* <Footer /> */}
    </div>
  );
};

export default WebDevelopment;
